import { auth } from "./firebase";

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () => auth.signOut();

// Sign in as anon
export const signInAnonymously = error => auth.signInAnonymously(error);

//onAuthStateChanged
export const onAuthStateChanged = changed => auth.onAuthStateChanged(changed);



// WEBPACK FOOTER //
// ./src/firebase/auth.js